import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAv1tX0H/gPAs6zseq0LQI
02YzT0XZ8LGsMf8r5d8x8QEV6ESX4MRkk1gGeMCOzlnjpHwuJGyFkp19M/N7vNtC
ceUXKM3z456m+2059FKvoqp3/u1h/19A3k7oWqpOJ/1ooJ3t1QPLbkxCWVunJxXl
P1AQBiqIMQJO6xDB2EXF/ILEaFqAuxIF2RJ9OMb5vBof/INFuHJzpiE2fhUzC7Lj
CdXivDs1l9r3nrU5XpiM8x+1d7lx8uSjgIITAjPSw09FYihv5PyW6HyRwGbOWKN9
EHX4T9MuzYbuNg6ZZ3yvnQon3ubYhhJ/ZQGrTijI+eUzNyk7CfGX4rTtfNM3fzpI
0QIDAQAB
-----END PUBLIC KEY-----`;

function generateRandomAESKey(length = 16) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

export function encryptDataHybrid(dataToEncrypt) {
  try {
    // ✅ Step 1: Create a fixed or generated 16-character key (safe for UTF-8)
    const aesKeyString = generateRandomAESKey(); // e.g., "a3Dx7F9bL0tYkQ2z"

    // ✅ Step 2: Convert to WordArray
    const rawKey = CryptoJS.enc.Utf8.parse(aesKeyString);

    // ✅ Step 3: Encrypt JSON payload
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(dataToEncrypt),
      rawKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedData = encrypted.toString(); // Base64

    // ✅ Step 4: Encrypt the AES key using RSA
    const rsa = new JSEncrypt();
    rsa.setPublicKey(RSA_PUBLIC_KEY);
    const encryptedKey = rsa.encrypt(aesKeyString); // Now safe

    if (!encryptedKey) throw new Error("RSA encryption failed");

    return {
      encryptedData,
      encryptedKey,
    };
  } catch (err) {
    console.error("🛑 Encryption failed:", err.message);
    return null;
  }
}

